export default [
    { path: '/admin/dashboard', component: require('./components/Dashboard.vue').default },
    { path: '/admin/profile', component: require('./components/AgentProfile.vue').default },
    { path: '/admin/developer', component: require('./components/Developer.vue').default },
    { path: '/admin/users', component: require('./components/Users.vue').default },
    { path: '/admin/variables', component: require('./components/Variables.vue').default },
    { path: '/admin/agents', component: require('./components/Agents.vue').default },
    { path: '/admin/listings/:listingId?', component: require('./components/Listing.vue').default },

    { path: '/admin/agents/listings/:slug', component: require('./components/AgentsListings.vue').default },
    { path: '/admin/agents/testimonials/:slug', component: require('./components/Testimonials.vue').default },

    { path: '/', component: require('./components/site/Homepage.vue').default },
    { path: '/browse/:criteria?', component: require('./components/site/Browse.vue').default },
    { path: '/openHouses', component: require('./components/site/Browse.vue').default,  props: { listing_type: "openHouses" }},
    { path: '/favorites', component: require('./components/site/Browse.vue').default,  props: { listing_type: "favorites" }},

    { path: '/about', component: require('./components/site/About.vue').default },
    { path: '/:slug', component: require('./components/AgentProfile.vue').default },
    { path: '/:slug?/testimonials', component: require('./components/AgentTestimonials.vue').default },
    { path: '/listing/:listingId', component: require('./components/site/Listing.vue').default },

    { path: '*', component: require('./components/NotFound.vue').default },

];
